import { useContext } from 'react';
import { TbHandMove as MoveMessageIcon } from 'react-icons/tb';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip, Zoom, IconButton, Typography, TextField, Grid, CircularProgress, LinearProgress } from '@mui/material';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { TbHandFinger as ChooseIcon } from 'react-icons/tb';
import { LocalizationIds } from 'helpers/Localizations';
import { moveMessageContext } from './MoveMessageContext';
import { useIntl } from 'react-intl';
import { FilterContainer, NoResultsTableFooter } from 'components';


let MoveMessage = () => {
    let { formatMessage } = useIntl();

    let service = useContext(moveMessageContext);

    return (
        <>
            <Tooltip title={formatMessage({ id: LocalizationIds.MoveMessage })} TransitionComponent={Zoom}>
                <IconButton
                    size="small"
                    color="primary"
                    onClick={service.open}
                >
                    <MoveMessageIcon />
                </IconButton>
            </Tooltip>

            <Dialog open={service.isOpen} fullWidth maxWidth="md">
                <DialogTitle>{formatMessage({ id: LocalizationIds.ChooseDestinationTicket })}</DialogTitle>
                <DialogContent>
                    <FilterContainer onSubmit={service.searchTickets}>
                        <Grid container>
                            <Grid item xs>
                                <TextField
                                    label={formatMessage({ id: LocalizationIds.Ticket })}
                                    variant="outlined"
                                    value={service.search}
                                    onChange={(e) => service.updateSearch(e.target.value)}
                                />
                            </Grid>
                            <Grid item>
                                <Button type="submit" variant="contained" color="secondary" size="large">
                                    <SearchIcon />
                                </Button>
                            </Grid>
                        </Grid>
                    </FilterContainer>
                    {service.isSearching && <LinearProgress />}
                    {service.isSearchDone &&
                        <Grid container>
                            <Grid item xs>
                                <Typography>{formatMessage({ id: LocalizationIds.TotalTickets })}&nbsp;{service.count}</Typography>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{formatMessage({ id: LocalizationIds.Ticket })}</TableCell>
                                            <TableCell>{formatMessage({ id: LocalizationIds.Customer })}</TableCell>
                                            <TableCell>{formatMessage({ id: LocalizationIds.Title })}</TableCell>
                                            <TableCell />
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {service.tickets.map(ticket =>
                                            <TableRow key={ticket.id} selected={service.selectedTicket?.id === ticket.id}>
                                                <TableCell>{ticket.ticketNumber}</TableCell>
                                                <TableCell>{ticket.customerName}</TableCell>
                                                <TableCell>{ticket.title}</TableCell>
                                                <TableCell>
                                                    {service.selectedTicket?.id !== ticket.id &&
                                                        <IconButton color="primary" onClick={() => service.chooseTicket(ticket)}>
                                                            <ChooseIcon />
                                                        </IconButton>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                    {service.tickets.length === 0 &&
                                        <NoResultsTableFooter colSpan={4} message={formatMessage({ id: LocalizationIds.NoDataFound })} />
                                    }
                                </Table>
                            </Grid>
                        </Grid>
                    }

                </DialogContent>
                <DialogActions>
                    <Button onClick={service.close} color="secondary" disabled={service.isSaving}>
                        {formatMessage({ id: LocalizationIds.Cancel })}
                    </Button>

                    {service.selectedTicket !== undefined &&
                        <Button onClick={async () => await service.moveMessage()} color="primary" disabled={service.isSaving}>
                            {service.isSaving && <><CircularProgress size={16} />&nbsp;</>}{formatMessage({ id: LocalizationIds.Confirm })}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default MoveMessage;